import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import jobCardReducer from './slices/jobCardSlice';
import partReducer from './slices/partSlice';
import customerReducer from './slices/customerSlice';
import vehicleReducer from './slices/vehicleSlice';
import userReducer from './slices/userSlice';
import invoiceReducer from './slices/invoiceSlice';
import dashboardReducer from './slices/dashboardSlice';
import serviceReducer from './slices/serviceSlice';
import quotationReducer from './slices/quotationSlice';
import cashReducer from './slices/cashSlice';
import expenseReducer from './slices/expenseSlice';
import whatsappReducer from './slices/whatsappSlice';
import glAccountsReducer from './slices/glAccountsSlice';

// Super Admin reducers
import companiesReducer from './slices/companiesSlice';
import garagesReducer from './slices/garagesSlice';
import subscriptionsReducer from './slices/subscriptionsSlice';
import superAdminUsersReducer from './slices/usersSlice';
import configurationsReducer from './slices/configurationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    jobCards: jobCardReducer,
    parts: partReducer,
    customers: customerReducer,
    vehicles: vehicleReducer,
    users: userReducer,
    invoices: invoiceReducer,
    dashboard: dashboardReducer,
    services: serviceReducer,
    quotations: quotationReducer,
    cash: cashReducer,
    expenses: expenseReducer,
    whatsapp: whatsappReducer,
    // ChartOfAccounts reads `useSelector((s) => s.glAccounts || {})`. That
    // `|| {}` meant an unregistered reducer threw nothing — the screen rendered
    // its "no accounts yet" empty state while the GET had returned a full
    // seeded chart. Every page test builds its own store, so 327 green suites
    // never saw it. Found by lane D3.
    glAccounts: glAccountsReducer,
    // Super Admin
    companies: companiesReducer,
    garages: garagesReducer,
    subscriptions: subscriptionsReducer,
    superAdminUsers: superAdminUsersReducer,
    configurations: configurationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
